import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Store } from '@ngxs/store';
import { Utility } from '../core/common';
import { UtmState } from '../states/utm.state';
import { AuthService } from './auth.service';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class CollectService {
  constructor(private http: HttpClient, private store: Store, private authService: AuthService) { }

  jobClickRedirected(id: string, jobId: string, isSponsored?: boolean) {
    return this.http.get<any[]>(environment.app.apiUrl + 'collect/job-click/' + jobId,
      { params: { id: id, redirect: 'true', sp: isSponsored }, context: SharedService.NO_LOADING_BAR }).toPromise();
  }

  jobClick(jobId: string, params: any, jobClickId?: string) {
    const user = this.store.selectSnapshot(state => state.auth.user);
    const guestId = this.authService.guestId;
    const rnd = (new Date()).getTime();

    const utm = this.store.selectSnapshot(UtmState.utm);
    const utmQuery = Utility.getUtmQueryUrl(utm);

    const isDirect = Object.getOwnPropertyNames(params).filter(_ => _.startsWith('utm_')).length > 0;

    const link = `${environment.app.apiUrl}collect/job-click/${jobId}?id=${jobClickId || ''}&r=${rnd}&gid=${guestId}&${(user ? 'userid=' + user.Id + '&' : '')}` +
      (isDirect ? 'direct=true&' : '') + (!!params['sp'] ? 'sp=true&' : '') +
      utmQuery;
    return this.http.get<any[]>(link, { context: SharedService.NO_LOADING_BAR }).toPromise();

  }

  getJobClicks(jobIds: string[]) {
    if (!jobIds || !jobIds.length) { return null; }
    return this.http.post(environment.app.apiUrl + 'collect/job-click', {}, { params: { 'jobId': jobIds }, context: SharedService.NO_LOADING_BAR }).toPromise();
  }

  jobSearch(q: string, l: string, _params: any) {
    const params = Object.assign(_params, { q: q || '', l: l || '' });
    return this.http.get<any[]>(environment.app.apiUrl + 'collect/job-search', { params, context: SharedService.NO_LOADING_BAR }).toPromise();
  }

  jobSearchLink(q: string, l: string, params: any) {
    const user = this.store.selectSnapshot(state => state.auth.user);
    return environment.app.apiUrl + 'collect/job-search?' +
      (user ? 'u=' + user.Id + '&' : '') +
      `q=${q || ''}&l=${l || ''}&` +
      Object.getOwnPropertyNames(params).map(_ => `${_}=${encodeURI(params[_])}`).join('&');
  }

  topQueries(limit = 20) {
    return this.http.get<string[]>(environment.app.apiUrl + 'collect/top/query/' + limit, { context: SharedService.NO_LOADING_BAR }).toPromise();
  }
}
